import { GlobalCommandModal } from '../../../../components/GlobalCommandModal'
import { CatalogItemDetailsPanelPresenter } from '../../../../features/run-conversation-turn/presenters/CatalogItemDetailsPanelPresenter'
import { RunConversationTurnPresenter } from '../../../../features/run-conversation-turn/presenters/RunConversationTurnPresenter'
import { ConversationFooter } from '../ConversationFooter'

export interface IConversationCommandModalProps {
  isOpen: boolean
  onClose: () => void
  onEntered?: () => void
  title: string
}

export const ConversationCommandModal = ({
  isOpen,
  onClose,
  onEntered,
  title,
}: IConversationCommandModalProps) => (
  <GlobalCommandModal
    isOpen={isOpen}
    onClose={onClose}
    onEntered={onEntered}
    isConversation
    title={title}
    footer={<ConversationFooter />}
    sidePanel={<CatalogItemDetailsPanelPresenter />}
  >
    <RunConversationTurnPresenter />
  </GlobalCommandModal>
)
